import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { Resolve } from '@angular/router';
import { Page } from 'src/app/core/models/Page';

@Injectable()
export class EmbargoReassignService {
  page: Page = new Page();

  constructor(
    private http: HttpClient
  ) {
    this.page.size = 100;
    this.page.pageNumber = 0;
    this.page.state = 1;
  }

  resolve(): Observable<any> {
    return this.getProcuratorList(this.page);
  }

  getProcuratorList(page) {
    const httpParams = new HttpParams({
      fromObject: page
    });

    return this.http.get<any>(`${environment.BACKEND}reasignarSoj/user/list`, {
      params: httpParams
    });
  }

  getCount(id) {
    return this.http.get<any>(`${environment.BACKEND}reasignarSoj/count/${id}`);
  }

  getDetalle(id) {
    return this.http.get<any>(`${environment.BACKEND}reasignarSoj/detalle/${id}`);
  }

  acceptAssignation(procu_id) {
    return this.http.post<any>(`${environment.BACKEND}reasignarSoj/aceptar`, {
      procu: procu_id
    });
  }
}
